import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

// NOTE Rationale behind using separate contexts for consumers and actors is
// avoiding unneeded re-renders of components that only act, but don't consume.

const AppAlertsStatusContext = createContext(null)
const AppAlertsActionsContext = createContext(null)

export const useAppAlertsStatusContext = () =>
  useContext(AppAlertsStatusContext)
export const useAppAlertsActionsContext = () =>
  useContext(AppAlertsActionsContext)

const AppAlertsProvider = ({ children }) => {
  const [showPrintDownloadAlert, setShowPrintDownloadAlert] = useState(false)
  const [showPrintAppNotInstalledAlert, setShowPrintAppNotInstalledAlert] =
    useState(false)
  const [showPrinterNotConfiguredAlert, setShowPrinterNotConfiguredAlert] =
    useState(false)

  const [showNewUserManualAlert, setShowNewUserManualAlert] = useState(false)
  const [showImportantAlert, setShowImportantAlert] = useState(false)

  useEffect(() => {
    if (
      !process.env.REACT_APP_SHOW_IMPORTANT_ALERT_ES &&
      !process.env.REACT_APP_SHOW_IMPORTANT_ALERT_EN &&
      !process.env.REACT_APP_SHOW_IMPORTANT_ALERT_PT
    )
      return
    setShowImportantAlert(true)
  }, [setShowImportantAlert])

  useEffect(() => {
    if (localStorage.getItem('userManualDate')===process.env.REACT_APP_SHOW_MANUAL_ALERT) return
    const daysD  = (new Date() - new Date(process.env.REACT_APP_SHOW_MANUAL_ALERT)) / (1000 * 60 * 60 * 24);
    if(daysD>=0 && daysD <=7){
      setShowNewUserManualAlert(true)
    }
  }, [showNewUserManualAlert])

  const [showCancelShippingsAlert, setShowCancelShippingsAlert] =
    useState(false)
  useEffect(() => {
    if (!showCancelShippingsAlert) return

    const timeoutId = window.setTimeout(() => {
      setShowCancelShippingsAlert(false)
    }, 5000)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [showCancelShippingsAlert])

  const [showCancelPrintAlert, setShowCancelPrintAlert] = useState(false)
  useEffect(() => {
    if (!showCancelPrintAlert) return

    const timeoutId = window.setTimeout(() => {
      setShowCancelPrintAlert(false)
    }, 5000)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [showCancelPrintAlert])

  const status = useMemo(
    () => ({
      showPrintDownloadAlert,
      showPrintAppNotInstalledAlert,
      showPrinterNotConfiguredAlert,
      showCancelShippingsAlert,
      showCancelPrintAlert,
      showNewUserManualAlert,
      showImportantAlert
    }),
    [
      showPrintAppNotInstalledAlert,
      showPrintDownloadAlert,
      showPrinterNotConfiguredAlert,
      showCancelShippingsAlert,
      showCancelPrintAlert,
      showNewUserManualAlert,
      showImportantAlert
    ],
  )

  const actions = useMemo(
    () => ({
      setShowPrintDownloadAlert,
      setShowPrintAppNotInstalledAlert,
      setShowPrinterNotConfiguredAlert,
      setShowCancelShippingsAlert,
      setShowCancelPrintAlert,
      setShowNewUserManualAlert,
      setShowImportantAlert
    }),
    [],
  )

  return (
    <AppAlertsStatusContext.Provider value={status}>
      <AppAlertsActionsContext.Provider value={actions}>
        {children}
      </AppAlertsActionsContext.Provider>
    </AppAlertsStatusContext.Provider>
  )
}
AppAlertsProvider.propTypes = {
  children: PropTypes.element.isRequired,
}

export default AppAlertsProvider
